module.exports = __webpack_public_path__ + "static/media/feature-3.a92f24ae.png";